var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            bottom: "",
            timeout: 3200,
            color: _vm.computedType.color,
            outlined: "",
            right: ""
          },
          on: { input: _vm.handleChange },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function(ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "va-button",
                    _vm._b(
                      {
                        attrs: {
                          icon: "vi vi-i-remove-1",
                          color: _vm.computedType.color,
                          type: "icon"
                        },
                        on: { click: _vm.dismiss }
                      },
                      "va-button",
                      attrs,
                      false
                    )
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.displayNotification,
            callback: function($$v) {
              _vm.displayNotification = $$v
            },
            expression: "displayNotification"
          }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _vm.type
                ? _c("va-icon", {
                    staticClass: "mr-3",
                    attrs: {
                      icon: _vm.computedType.icon,
                      color: _vm.computedType.color
                    }
                  })
                : _vm._e(),
              _vm._v(" " + _vm._s(_vm.message) + " ")
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }